export default {
  SET_LIST_MAIL_TEMPLATE(state, listMailTemplate) {
    let result = [];
    result = listMailTemplate.filter(item => item.state_flg != 1);
    state.listMailTemplate = result;
  },
}